import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import type { CommunityEmptyStateTab } from '~publish/components/CommunityEmptyState'

const PUBLIC_TABS: CommunityEmptyStateTab[] = ['comments', 'mentions']

function isPublicTab(value: string | null): value is CommunityEmptyStateTab {
  return PUBLIC_TABS.some((tab) => tab === value)
}

export function usePublicCommunityTab(): [
  CommunityEmptyStateTab,
  (tab: string) => void,
] {
  const location = useLocation()
  const navigate = useNavigate()
  const tabParam = new URLSearchParams(location.search).get('tab')
  const tab = isPublicTab(tabParam) ? tabParam : PUBLIC_TABS[0]

  const setTab = useCallback(
    (nextTab: string): void => {
      if (!isPublicTab(nextTab)) return
      const searchParams = new URLSearchParams(location.search)
      searchParams.set('tab', nextTab)
      navigate({
        pathname: location.pathname,
        search: searchParams.toString(),
        hash: location.hash,
      })
    },
    [location, navigate],
  )

  return [tab, setTab]
}
